var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.955,
    height: 26.956,
    viewBox: "0 0 26.955 26.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comm-17_chat",
    d: "M21.23.529a6.248,6.248,0,0,1,6.24,6.254l.014,8.643a6.221,6.221,0,0,1-5.79,6.21v5.4a.449.449,0,0,1-.768.318L15.268,21.68h-8.5a6.243,6.243,0,0,1-6.24-6.254V6.783A6.232,6.232,0,0,1,6.755.529ZM18.5,9.758a1.348,1.348,0,1,0,1.348,1.348A1.354,1.354,0,0,0,18.5,9.758Zm-4.492,0a1.348,1.348,0,1,0,1.348,1.348A1.355,1.355,0,0,0,14.007,9.758Zm-4.493,0a1.348,1.348,0,1,0,1.349,1.348A1.355,1.355,0,0,0,9.513,9.758Z",
    transform: "translate(-0.529 -0.529)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ee744fcc3896ba75bd7d7797f7ea852a.svg";
export { ForwardRef as ReactComponent };